// (C) Copyright 2024 Hewlett Packard Enterprise Development LP
import { Box } from 'grommet'
import { Search } from 'grommet-icons'
import PropTypes from 'prop-types'

import { Typography } from '../../../../../components'

import SuggestionContainer from './SuggestionContainer'

const SuggestedSearches = ({ query, index, t }) => {
  return (
    <SuggestionContainer>
      <Box direction="column" gap="small" data-testid="suggested-searches">
        {index === 0 && (
          <Typography type="text" size="xsmall">
            {t('suggested_searches')}
          </Typography>
        )}
        <Box direction="row" gap="small">
          <Box pad={{ top: 'xsmall' }}>
            <Search />
          </Box>
          <Typography type="text" weight={500}>
            {query}
          </Typography>
        </Box>
      </Box>
    </SuggestionContainer>
  )
}

SuggestedSearches.propTypes = {
  query: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  t: PropTypes.func.isRequired
}

export default SuggestedSearches
